import React from 'react';
import striptags from 'striptags';
import { FacebookShareButton, TelegramShareButton, VkShareButton } from 'cityads-v3/components/Social';
import config from 'cityads-v3/config';

export const NEWS_BODY_MAX_LENGTH = 200;
export const NEWS_PREVIEW_CUTTER = '<ca-cut />';

export function parseNewsItem(item){
  return {
    ...item,
    body: item && item.body && item.body.replace(/="\.\.\/\.\.\/\.\.(\/local)/, `="${config.NEWS_URL}$1`),
    cutted: item && striptags(item.body.split(NEWS_PREVIEW_CUTTER)[0]),
    textBody: item && striptags(item.body)
  };
}

export function getNewsFields(news, t, pathname, classes = {}) {
  if (!news) { return null; }

  const { title, /*image: newsImage,*/ body, date_publish, cutted } = news;
  const truncatedText = truncateWithCutter(cutted);
  const text = <div className={classes.newsShortText} dangerouslySetInnerHTML={{ __html: truncatedText }}></div>; // truncatedText может содержать HTML entitites
  const moreTitle = title;
  const image = extractImgSrcFromHTML(body) /*|| newsImage*/ || null;
  const moreText = getFullText({ title, image, body, t, pathname, classes });

  return { title, image, text, moreTitle, moreText, date_publish };
}

function getFullText({ title, image, body, t, pathname, classes = {} }) {
  const newsUrl = (window ? window.location.origin : '') + pathname;
  return (
    <div>
      <div className={classes.newsText} dangerouslySetInnerHTML={{ __html: body }}></div>
      <div>
        <VkShareButton
          key     = "vk"
          url     = {newsUrl}
          tooltip = {t('main:social.share.vk')}
          title   = {title}
          image   = {image}
        />
        <FacebookShareButton
          key     = "fb"
          url     = {newsUrl}
          tooltip = {t('main:social.share.facebook')}
        />
        <TelegramShareButton
          key     = "tg"
          url     = {newsUrl}
          tooltip = {t('main:social.share.telegram')}
        />
      </div>
    </div>
  );
}

function truncateWithCutter(text) {
  const withCutter = text.indexOf(NEWS_PREVIEW_CUTTER) !== -1;

  if (withCutter) {
    return text.split(NEWS_PREVIEW_CUTTER)[0];
  }

  return (text.length <= NEWS_BODY_MAX_LENGTH) ? text : text.substr(0, NEWS_BODY_MAX_LENGTH - 1) + '…';
}

export function extractImgSrcFromHTML(text) {
  if (text) {
    const match = text.match(/<img[^>]+src=['"]{0,1}([^'"]+)['"]{0,1}/);
    return match && match[1];
  }
}
